module.exports = __webpack_public_path__ + "static/media/curtain-wall-spraying-001.8d59be6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/curtain-wall-spraying-001.jpg
// module id = 94
// module chunks = 0